<template lang="html" src="./exterior-interior.section.html"></template>
<style
  lang="scss"
  scoped
  src="./_exterior-interior.section.mobile.scss"
></style>
<style
  lang="scss"
  scoped
  src="./_exterior-interior.section.desktop.scss"
></style>

<script>
export default {
  name: "ExteriorInteriorSection",
  props: ["isActive", "isLearnMoreActive"],
  data() {
    return {
      currSlide: "first"
    };
  },
  methods: {
    openLearnMore() {
      if (!this.isLearnMoreActive) {
        this.$emit("learn-more", "exterior-interior");
      }
    },
    closeLearnMore() {
      this.$emit("learn-more", "main");
    },
    changeSlide(slide) {
      const slideImg = document.querySelector(".subsection-2 > .img");
      slideImg.classList = `img ${slide}`;
      this.currSlide = slide;
    }
  }
};
</script>
